/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Importing_VideoInputs */



/**
* | output |
* | --- |
* | "Importing video file..." |
*
* @param {Ateliere_Connect_Status_Importing_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_importing_video = /** @type {((inputs?: Ateliere_Connect_Status_Importing_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Importing_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du fichier vidéo...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videodatei wird importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del file video...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт видеофайла...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando archivo de vídeo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入视频文件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオファイルをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो फ़ाइल आयात की जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando arquivo de vídeo...")
	return /** @type {LocalizedString} */ ("Importing video file...")
});